import { GlIcon, GlTooltip } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import IssueHealthStatus from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/issues/components/issue_health_status.vue?vue3';
import WorkItemLinkChildMetadata from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/shared/work_item_link_child_metadata.vue?vue3';
import WorkItemRolledUpHealthStatus from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/components/work_item_links/work_item_rolled_up_health_status.vue?vue3';
import WorkItemIterationAttribute from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/components/shared/work_item_iteration_attribute.vue?vue3';
import { WIDGET_TYPE_HEALTH_STATUS, WIDGET_TYPE_PROGRESS, WIDGET_TYPE_WEIGHT, WIDGET_TYPE_ITERATION, WIDGET_TYPE_START_AND_DUE_DATE, METADATA_KEYS } from '~/work_items/constants';
import { localeDateFormat, newDate } from '~/lib/utils/datetime_utility';
import timeagoMixin from '~/vue_shared/mixins/timeago';
import WorkItemAttribute from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/work_item_attribute.vue?vue3';
import WorkItemDatesAttribute from '/builds/gitlab/gitlab-ee/app/assets/javascripts/work_items/components/shared/work_item_dates_attribute.vue?vue3';
export default {
    name: 'WorkItemLinkChildEE',
    components: {
        GlIcon,
        GlTooltip,
        IssueHealthStatus,
        WorkItemLinkChildMetadata,
        WorkItemRolledUpHealthStatus,
        WorkItemAttribute,
        WorkItemDatesAttribute,
        WorkItemIterationAttribute
    },
    mixins: [
        timeagoMixin
    ],
    props: {
        reference: {
            type: String,
            required: true
        },
        metadataWidgets: {
            type: Object,
            required: false,
            default: ()=>({})
        },
        isChildItemOpen: {
            type: Boolean,
            required: false,
            default: true
        },
        hiddenMetadataKeys: {
            type: Array,
            required: false,
            default: ()=>[]
        },
        namespacePath: {
            type: String,
            required: true
        }
    },
    computed: {
        progress () {
            return this.metadataWidgets[WIDGET_TYPE_PROGRESS]?.progress;
        },
        progressLastUpdatedAtInWords () {
            return this.getTimestampInWords(this.metadataWidgets[WIDGET_TYPE_PROGRESS]?.updatedAt);
        },
        progressLastUpdatedAtTimestamp () {
            return this.getTimestamp(this.metadataWidgets[WIDGET_TYPE_PROGRESS]?.updatedAt);
        },
        healthStatus () {
            return this.metadataWidgets[WIDGET_TYPE_HEALTH_STATUS]?.healthStatus;
        },
        rolledUpHealthStatus () {
            return this.metadataWidgets[WIDGET_TYPE_HEALTH_STATUS]?.rolledUpHealthStatus;
        },
        hasProgress () {
            return Number.isInteger(this.progress);
        },
        weight () {
            return this.metadataWidgets[WIDGET_TYPE_WEIGHT]?.weight;
        },
        rolledUpWeight () {
            return this.metadataWidgets[WIDGET_TYPE_WEIGHT]?.rolledUpWeight;
        },
        workItemWeight () {
            return this.rolledUpWeight || this.weight;
        },
        iteration () {
            return this.metadataWidgets[WIDGET_TYPE_ITERATION]?.iteration;
        },
        startDate () {
            return this.metadataWidgets[WIDGET_TYPE_START_AND_DUE_DATE]?.startDate;
        },
        dueDate () {
            return this.metadataWidgets[WIDGET_TYPE_START_AND_DUE_DATE]?.dueDate;
        },
        showDate () {
            return this.startDate || this.dueDate;
        },
        showWeight () {
            return this.workItemWeight && !this.hiddenMetadataKeys.includes(METADATA_KEYS.WEIGHT);
        },
        showIteration () {
            return this.iteration && !this.hiddenMetadataKeys.includes(METADATA_KEYS.ITERATION);
        },
        showDates () {
            return this.showDate && !this.hiddenMetadataKeys.includes(METADATA_KEYS.DATES);
        },
        showHealthStatus () {
            return !this.hiddenMetadataKeys.includes(METADATA_KEYS.HEALTH);
        },
        showRolledUpHealthStatus () {
            return this.rolledUpHealthStatus && this.showHealthStatus;
        },
        showHealthStatusIndicator () {
            return this.healthStatus && this.isChildItemOpen && this.showHealthStatus;
        }
    },
    methods: {
        getTimestamp (rawTimestamp) {
            return rawTimestamp ? localeDateFormat.asDateTimeFull.format(newDate(rawTimestamp)) : '';
        },
        getTimestampInWords (rawTimestamp) {
            return rawTimestamp ? this.timeFormatted(rawTimestamp) : '';
        }
    }
};
